import { Component } from 'solid-js'
import { i18nStore } from '../../../store'
import Select from '../../../shared/Select'
import { FormLabel } from '../../../shared/FormLabel'

export const VisibilitySelect: Component<{
  value: string
  onChange: (value: string) => void
}> = (props) => {
  const i18n = i18nStore()

  const options = [
    { value: 'public', label: (i18n as any).t.char_visibility_public },
    { value: 'unlisted', label: (i18n as any).t.char_visibility_unlisted },
    { value: 'private', label: (i18n as any).t.char_visibility_private },
  ]

  return (
    <div class="flex flex-col gap-1">
      <FormLabel label={(i18n as any).t.char_visibility} />
      <Select
        items={options}
        value={props.value}
        onChange={(opt) => props.onChange(opt.value)}
      />
    </div>
  )
}








